import { colors2 } from "oolib"


export const LAYOUT_CONSTANTS = {
    pagePadding : 16,
    topBottomPadding: 8,
    cardBorderRadius: 6
} 

export const BREADCRUMB_WRAPPER_STYLE = {
  padding: `0 ${LAYOUT_CONSTANTS.pagePadding + "px"}`,
  borderBottom: `1px solid ${colors2.grey5}`,
}